export function readArray(value) {
  return Array.isArray(value) ? value : [];
}

export function readFiniteNumber(value) {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

export function toTimeValuePoints(values, times, samplingRateHz = 30) {
  if (!Array.isArray(values)) return [];

  return values
    .map((value, index) => {
      if (typeof value !== "number" || !Number.isFinite(value)) return null;

      const timeValue =
        Array.isArray(times) &&
        typeof times[index] === "number" &&
        Number.isFinite(times[index])
          ? times[index]
          : index / samplingRateHz;

      return { t: timeValue, value, index };
    })
    .filter(Boolean);
}

export function normaliseTimeValuePoints(points) {
  if (!Array.isArray(points) || !points.length) return [];

  const firstT = readFiniteNumber(points[0]?.t) ?? 0;

  return points.map((point, index) => ({
    ...point,
    t: (readFiniteNumber(point?.t) ?? firstT) - firstT,
    index,
  }));
}

export function getTimeSeriesMaxSecs(times, fallback = 1) {
  const values = readArray(times).filter(
    (value) => typeof value === "number" && Number.isFinite(value),
  );

  if (!values.length) return fallback;

  const first = values[0];
  const last = values[values.length - 1];

  return Math.max(1, Math.ceil(last - first));
}

export function getPointSeriesMaxSecs(points, fallback = 60) {
  if (!Array.isArray(points) || !points.length) return fallback;

  const lastT = points[points.length - 1]?.t;

  return typeof lastT === "number" && Number.isFinite(lastT)
    ? Math.max(1, Math.ceil(lastT))
    : fallback;
}
